import {
	Checkbox,
	Grid,
	TableCell,
	TableRow,
	TextField
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React from "react";
import Chip from "@material-ui/core/Chip";
import IconButton from "@material-ui/core/IconButton";
import TrashCan24 from "@carbon/icons-react/lib/trash-can/24";
import classnames from "classnames";
import PlayerFormat from "../../../util/player-format";
import commonStyles from "../../common/styles/Common.styles";

const PlayerImportRow = ({
	player,
	positions,
	teamPlayers,
	onChange = () => {},
	onPlayerDelete = () => {}
}) => {
	const commonClasses = commonStyles();

	const {
		importIndex,
		firstName,
		lastName,
		number,
		positionMatch,
		playerMatch,
		errors
	} = player;

	const getFieldErrors = (field) => {
		return player.errors?.[field]?.join(", ") || "";
	};

	return (
		<TableRow
			key={importIndex}
			className={classnames({
				[commonClasses.error]: Object.keys(errors).length
			})}
		>
			<TableCell>
				<Grid container spacing={1}>
					<Grid item md={6}>
						<TextField
							value={firstName}
							error={!!getFieldErrors("firstName")}
							helperText={getFieldErrors("firstName")}
							inputProps={{ "aria-label": "First Name" }}
							onChange={(event) =>
								onChange(Object.assign(player, { firstName: event.target.value }))
							}
						/>
					</Grid>
					<Grid item md={6}>
						<TextField
							value={lastName}
							error={!!getFieldErrors("lastName")}
							helperText={getFieldErrors("lastName")}
							inputProps={{ "aria-label": "Last Name" }}
							onChange={(event) =>
								onChange(Object.assign(player, { lastName: event.target.value }))
							}
						/>
					</Grid>
				</Grid>
			</TableCell>
			<TableCell>
				<TextField
					value={number}
					error={!!getFieldErrors("number")}
					helperText={getFieldErrors("number")}
					inputProps={{ "aria-label": "Number" }}
					onChange={(event) =>
						onChange(Object.assign(player, { number: event.target.value }))
					}
				/>
			</TableCell>
			<TableCell>
				<Autocomplete
					limitTags={2}
					options={positions}
					getOptionLabel={(option) => `${option.name} (${option.code})`}
					onChange={(event, value) => {
						onChange(Object.assign(player, { positionMatch: value }));
					}}
					getOptionSelected={(option, value) => {
						return option.code === value.code;
					}}
					defaultValue={positionMatch}
					multiple
					renderOption={(option, { selected }) => (
						<>
							<Checkbox color="primary" size="small" checked={selected} />
							<span>
								{option.name} ({option.code})
							</span>
						</>
					)}
					renderInput={(params) => <TextField {...params} variant="outlined" />}
					renderTags={(tags, getTagProps) => {
						return tags.map((option, i) => (
							<Chip {...getTagProps({ index: i })} label={option.code} />
						));
					}}
				/>
			</TableCell>
			<TableCell>
				<Autocomplete
					options={teamPlayers}
					getOptionLabel={PlayerFormat.getFullName}
					renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							error={!!getFieldErrors("playerMatch")}
							helperText={getFieldErrors("playerMatch")}
							placeholder="New Player"
						/>
					)}
					onChange={(event, value) => {
						onChange(Object.assign(player, { playerMatch: value }));
					}}
					getOptionSelected={(option, value) => {
						return option.uniform === value.uniform;
					}}
					value={playerMatch}
				/>
			</TableCell>
			<TableCell>
				<IconButton
					aria-label="Delete player"
					onClick={() => onPlayerDelete(player)}
				>
					<TrashCan24 />
				</IconButton>
			</TableCell>
		</TableRow>
	);
};

export default PlayerImportRow;
